import { Body14Regular } from "../typography/Body14Regular";
import { Footnote12Description } from "../typography/Footnote12Description";
import { H5 } from "../typography/H5";

export const PartnerCustomerCenterPanel = () => {
  return (
    <div className="flex flex-col w-full items-center justify-center gap-[8px] text-semantic-text-tertiary">
      <div className="flex items-center justify-center gap-[8px]">
        <Body14Regular>아카라 고객센터</Body14Regular>
        <a 
          href="https://aqarabiz.channel.io/home" 
          target="_blank" 
          rel="noopener noreferrer"
          className="hover:underline"
        >
          <H5>온라인 채널톡 문의</H5>
        </a>
      </div>
      <Footnote12Description>
        [상담 운영 시간] 평일 : 9:00 ~ 11:30, 13:00 ~ 17:00, 주말 및 공휴일 휴무
      </Footnote12Description>
    </div>
  );
};
